// Apply panning logic. Adds a listener for panning with the middle mouse button,

import { useRef, useState, useEffect } from 'react'

// and allows entering and exiting pan mode.
export default function usePan(activeCanvas, canvases) {
  const prevMousePosRef = useRef(null)

  const [isPanning, setIsPanning] = useState(false)

  const togglePanMode = () => {
    setIsPanning(!isPanning)
  }

  useEffect(
    function applyPanMode() {
      if (activeCanvas) {
        Object.values(canvases).forEach((c) => {
          c.selection = !isPanning
          c.skipTargetFind = isPanning
          c.defaultCursor = isPanning ? 'grab' : 'default'
          c.forEachObject((obj) => {
            obj.selectable = !isPanning
            obj.evented = !isPanning
          })
        })
      }
    },
    [activeCanvas, canvases, isPanning],
  )

  useEffect(() => {
    // Set up listeners for panning events outside of react for performance reasons.
    const handlePanStart = (clientX, clientY) => {
      prevMousePosRef.current = { x: clientX, y: clientY }
    }

    const handleMousedown = (e) => {
      if (e.button === 1 || isPanning) {
        handlePanStart(e.clientX, e.clientY)
      }
    }

    const handlePanningMouseMove = (e) => {
      // TODO: These need to be on window in case mouse goes off the canvas.
      if (!prevMousePosRef?.current) return

      const dx = (e.clientX - prevMousePosRef.current.x) * 2
      const dy = (e.clientY - prevMousePosRef.current.y) * 2

      activeCanvas.relativePan({ x: dx, y: dy })
      prevMousePosRef.current = { x: e.clientX, y: e.clientY }
    }

    const handlePanEnd = () => {
      prevMousePosRef.current = null
    }

    window.addEventListener('mousedown', handleMousedown)
    window.addEventListener('mousemove', handlePanningMouseMove)
    window.addEventListener('mouseup', handlePanEnd)

    return () => {
      window.removeEventListener('mousedown', handleMousedown)
      window.removeEventListener('mousemove', handlePanningMouseMove)
      window.removeEventListener('mouseup', handlePanEnd)
    }
  }, [activeCanvas, isPanning])

  return { isPanning, togglePanMode }
}
